import { computed } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { useProductStore } from '~/stores/useProductStore';

export default function useProducts (hubbleClient) {
  if (!hubbleClient) {
    throw new Error('You must provide the hubbleClient to use this composable');
  }
  const productStore = useProductStore()
  const {
    productList,
    loading,
    currentCategoryID
  } = storeToRefs(productStore)
  const getProductsByCategoryID = async (categoryID, refresh) => {
    if (!refresh && (categoryID === currentCategoryID.value && productList.value.length)) {
      return productList.value
    }

    currentCategoryID.value = categoryID
    loading.value = true;
    const res = await hubbleClient.products.getFamilyByCategory(categoryID);
    productList.value = res.data;
    loading.value = false
    return productList.value;
  }

  const getProductDetails = async (categorySlug, productSlug) => {
    loading.value = true;
    try {
      const res = await hubbleClient.products.getProductDetails(categorySlug, productSlug)
      return res.data
    } catch (error) {
      return false
    } finally {
      loading.value = false
    }
  }

  const getProductsGroupedBySubscription = async (categoryId, subscriptionId) => {
    loading.value = true;
    try {
      const res = await hubbleClient.products.getProductsGroupedBySubscription(categoryId, subscriptionId);
      loading.value = false
      return res.data
    } catch (error) {
      return false
    } finally {
      loading.value = false
    }
  }
  return {
    getProductsGroupedBySubscription,
    getProductDetails,
    getProductsByCategoryID,
    loading: computed(() => loading.value),
    productList: computed(() => productList.value)
  }
}
